<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="5">
					<plant-select />
				</el-col>
				<el-col :span="4">
					<search-input :label="getMessage_('SWCC000104')" paramKey="permGrpCd" />
				</el-col>
				<el-col :span="4">
					<search-input :label="getMessage_('SWCC000105')" paramKey="userGrpName" />
				</el-col>
				<el-col :span="5">
					<useYn-select @search="() => searchList()" />
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/UserGroupManagement/store/helpers';
import PlantSelect from './PlantSelect.vue';
import UseYnSelect from './UseYnSelect.vue';
import SearchInput from './SearchInput.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { PlantSelect, UseYnSelect, SearchInput },
	computed: {
		...serviceComputed,
		...rootComputed
	},
	methods: {
		...serviceMethods,
		async searchList(currentPage = 1, pageUnit = this.groups.pageUnit) {
			this.$sf_toggleLoading(true);

			let searchParams = {
				permGrpCd: this.searchParams.permGrpCd,
				plantCd: this.searchParams.plantCd,
				userGrpName: this.searchParams.userGrpName,
				useYn: this.searchParams.useYn
			};

			// console.log('seaerch : ', searchParams);

			await this.getGroups_({ searchParams, currentPage, pageUnit })
				.then(header => {})
				.catch(e => {
					this.$sf_toast({
						type: 'error',
						message: e.message ? e.message : e
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	},
	created() {
		this.getPlants_()
			.then(() => {
				this.searchList();
				this.getCommCodes_({ key: 'useYnList', codeType: 'USE_YN' })
					.then(() => {
						this.useYnList.forEach(row => {
							this.gridUseYnList.push({
								label: row.commCdName,
								value: row.commCd
							});
						});
					})
					.catch(e => {
						this.$sf_toast({
							type: 'error',
							message: e.message ? e.message : e
						});
						Promise.reject(error);
					});
			})
			.catch(e => {
				this.$sf_toast({
					type: 'error',
					message: e.message ? e.message : e
				});
				Promise.reject(error);
			});
	},
	watch: {
		langCd() {
			//store 초기화
			this.resetYnState_();

			//다국어 재조회
			this.getCommCodes_({ key: 'useYnList', codeType: 'USE_YN' })
				.then(() => {
					this.useYnList.forEach(row => {
						this.gridUseYnList.push({
							label: row.commCdName,
							value: row.commCd
						});
					});
				})
				.catch(e => {
					this.$sf_toast({
						type: 'error',
						message: e.message ? e.message : e
					});
					Promise.reject(error);
				});
		}
	}
};
</script>

<style></style>
